import { ClearFilter } from "@/features/common/components/filter/ClearFilter";
import { MobileFilterDialogViewProps } from "@/features/common/components/filter/MobileFilterDialogView";

export const FilterSideBar = (
  {
    filterList,
    className = "",
  }: MobileFilterDialogViewProps & { className?: string },
) => {
  return (
    <aside className={className}>
      <h2 className="sr-only">Filters</h2>
      <div className="hidden sm:block">
        <form className="space-y-5" onSubmit={(e) => e.preventDefault()}>
          {filterList.map(({ title, component }, index) => (
            <fieldset className="space-y-3" key={index}>
              <legend className="block text-sm text-gray-700">{title}</legend>
              {component}
            </fieldset>
          ))}
          <ClearFilter />
        </form>
      </div>
    </aside>
  );
};
